export default {
  resetFilter({ commit, state }) {
    commit('updateFilterColor', []);
    commit('updateFilterCategory', []);
    commit('updateFilterOpacity', []);
    commit('updateSearchValue', '');
  }
}
